import workforceEventHandlers from "@/modules/workforce-integrations/events/event-handlers"
import events from "@/modules/login/events/events"
import { EventRegister } from "@common/events/event-register"

export const registerEventListeners: EventRegister = (eventBus) => {
  eventBus.$on(events.LOG_IN, workforceEventHandlers.handleLogInEvent)
  eventBus.$on(events.LOG_OUT, workforceEventHandlers.handleLogOutEvent)
}
